import { PendingWorkService } from "../services/pending-work/pending-work.service";
import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
} from "@angular/core";

export function pendingWorkProvider(): EnvironmentProviders {
  // Inject the service at bootstrap so its DOM reflection starts immediately
  return provideEnvironmentInitializer(() => inject(PendingWorkService));
}
